module.exports = __webpack_public_path__ + "img/send.b0519b7e.svg";